import { useMemo } from "react";
import {
  getVendorListDetailStickyKey,
  loadVendorListDetailStickyFilterState,
} from "../utils/vendorStickyFilterPersistence";
import useStickySelectedIds from "./useStickySelectedIds";

/**
 * Sticky selectedIds for a vendor list detail screen.
 */
export default function useVendorListDetailStickyFilters(listId) {
  const screenKey = useMemo(
    () => getVendorListDetailStickyKey(listId),
    [listId]
  );

  return useStickySelectedIds(screenKey, loadVendorListDetailStickyFilterState);
}
